export enum PanelType {
    Dashboard,
    Timeline,
    ContentEditor,
    DevicePanel,
    BrowserPanel,
    Notepad,
    Mixer,
    ModularSystem,
    VUMeter,
    MidiFall,
    ProjectInfo,
    ShadertoyPreview,
    ShadertoyEditor,
    EmptyFlexSpace
}